var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrongg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 240 240",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface140431054"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 56 32 C 53.953125 32 51.902344 32.78125 50.34375 34.34375 L 34.34375 50.34375 C 31.214844 53.472656 31.214844 58.535156 34.34375 61.65625 L 92.6875 120 L 34.34375 178.34375 C 31.214844 181.472656 31.214844 186.535156 34.34375 189.65625 L 50.34375 205.65625 C 53.472656 208.785156 58.535156 208.785156 61.65625 205.65625 L 120 147.3125 L 178.34375 205.65625 C 181.464844 208.785156 186.535156 208.785156 189.65625 205.65625 L 205.65625 189.65625 C 208.785156 186.527344 208.785156 181.464844 205.65625 178.34375 L 147.3125 120 L 205.65625 61.65625 C 208.785156 58.535156 208.785156 53.464844 205.65625 50.34375 L 189.65625 34.34375 C 186.527344 31.214844 181.464844 31.214844 178.34375 34.34375 L 120 92.6875 L 61.65625 34.34375 C 60.09375 32.78125 58.046875 32 56 32 Z M 56 32 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongg);
export default __webpack_public_path__ + "static/media/wrongg.0883e15ba7ac457309f51fc377c3f45c.svg";
export { ForwardRef as ReactComponent };